<template>
  <v-card>
    <v-card-title class="headline">{{ $t("imprint.title") }}</v-card-title>
    <v-card-text>
      <p
        v-for="paragraph in $t('imprint.paragraphs')"
        :key="paragraph"
        v-html="paragraph"
      ></p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
/** @define SlcTermsAndConditions; weak */
</style>
